/* unplugin-vue-components disabled */import { render } from "./Broadband.vue?vue&type=template&id=1f8197c4&scoped=true"
import script from "./Broadband.vue?vue&type=script&lang=js"
export * from "./Broadband.vue?vue&type=script&lang=js"

import "./Broadband.vue?vue&type=style&index=0&id=1f8197c4&scoped=true&lang=css"

import exportComponent from "E:\\myprogram\\52haoma_new\\new-haoma52\\haoma52-index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8197c4"]])

export default __exports__